import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { useSelector } from "react-redux";
import { getAccountUsers } from "../../api/account";
import { useTranslationHook } from "../../hooks";
import { PrivateSettings } from "../../types/interfaces/app";
import { User } from "../../types/interfaces/user";
import { StoreInterfaces } from "../../types/store/StoreInterfaces";
import { getRoleLabelFromId } from "../../utils/App";

interface AccountUserListProps {
  accountId: number;
  onUserSelected?: (userId: number) => void;
  refreshTrigger?: any;
}

const AccountUserList = (props: AccountUserListProps) => {
  const { t } = useTranslationHook();

  const privateSettings: PrivateSettings | undefined = useSelector(
    (state: StoreInterfaces) => state.app.privateSettings
  );

  const [accountId, setAccountId] = React.useState(0);
  const [userList, setUserList] = React.useState<User[]>([]);
  const [selectedCard, setSelectedCard] = React.useState(0);

  const { onUserSelected } = props;

  const getUserList = () => {
    getAccountUsers(accountId)
      .then((response) => {
        setUserList(response);
        enqueueSnackbar(t("admin.users.user-list-load-success"), {
          variant: "success",
        });
      })
      .catch((error) => {
        enqueueSnackbar(t("admin.users.user-list-load-error"), {
          variant: "error",
        });
      })
      .finally(() => {});
  };

  React.useEffect(() => {
    if (selectedCard === 0) return;
    onUserSelected?.(selectedCard);
    setSelectedCard(0);
  }, [selectedCard]);

  React.useEffect(() => {
     if (!accountId || accountId === 0) return;
     getUserList();
    }, [accountId, props.refreshTrigger]);

  React.useEffect(() => {
    setAccountId(props.accountId);
  }, [props.accountId]);

  return (
    <Box sx={{ width: "100%", mt: "2em" }}>
      {userList.map((user) => {
        return (
          <Card key={"user-" + user.id} sx={{ mb: 2 }}>
            <CardActionArea
              onClick={() => setSelectedCard(user.id)}
              data-active={selectedCard === user.id ? "" : undefined}
            >
              <CardContent>
                <Typography variant="h5" component="div">
                  {user.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t(getRoleLabelFromId(user.roleId, privateSettings?.roles))}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ({user.email})
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        );
      })}
    </Box>
  );
};

export default AccountUserList;
